import { createFeatureSelector, createSelector } from '@ngrx/store';
import { StoreTypes } from "mbs-ui-shared@store/storeTypes.enum";
import { SnmpAlertStoreData } from './model';

const selectSnmpAlertStoreData = createFeatureSelector<SnmpAlertStoreData>(StoreTypes.SnmpAlerts);
export const selectStoreData = createSelector(selectSnmpAlertStoreData, (state) => state);
export const selectLoading = createSelector(selectSnmpAlertStoreData, (state) => state.loading);
export const selectPickedAlertGuids = createSelector(selectSnmpAlertStoreData, (state) => state.selectedSnmpAlertGuids);
export const selectDeviceTypes = createSelector(selectSnmpAlertStoreData, (state) => state.deviceTypes);
export const selectAlertTypes = createSelector(selectSnmpAlertStoreData, (state) => state.alertTypes);
export const selectDeviceTypeProperties = createSelector(selectSnmpAlertStoreData, (state) => state.snmpDeviceCustomProperty);
